import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const FitOnboardedDashboard = () => {
  const [onboardedData, setOnboardedData] = useState([]);
  const [expandedCardId, setExpandedCardId] = useState(null);
  const [access, setAccess] = useState(null);
  const navigate = useNavigate();
  const location = useLocation()
  const [pid] = useState(location?.state?.pid )

  useEffect(() => {
    if (pid == null) {
      navigate('/');
    } else {
      const body = { "username": pid, "scope": "participant" };
      let connectionString = "https://app.digitalwellnessnurse.com";

      fetch(`${connectionString}/api/portal/verify`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: "include",
        body: JSON.stringify(body),
      })
        .then((response) => {
          setAccess(response.status);
          return response.json();
        })
        .then((json) => {
          if (json.access !== 200) {
            navigate('/');
          } else {
            fetchOnboardedData();
          }
        })
        .catch((error) => {
          console.error("Error verifying access:", error);
        });
    }
  }, [pid, navigate]);

  const fetchOnboardedData = async () => {
    try {
      const response = await fetch('https://app.digitalwellnessnurse.com/api/portal/fit/get-onboarded', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await response.json();
      setOnboardedData(data);
    } catch (error) {
      console.error('Error fetching onboarded data:', error);
    }
  };

  const toggleDetails = (id) => {
    setExpandedCardId((prev) => (prev === id ? null : id));
  };

  const onboardSocialSupport = (supporting) => {
    navigate('/FitSocialSupportOnboard', { state: { supporting:supporting, pid:pid } });
  };

  const metersToFeetInches = (meters) => {
    const totalInches = Math.round(meters * 39.3701);
    const feet = Math.floor(totalInches / 12);
    const inches = totalInches % 12;
    return `${feet}ft ${inches}in`;
  };

  const kgsToLbs = (kgs) => Math.round(kgs * 2.20462);

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Participating Families</h1>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
        {onboardedData.map((doc) => {
          const { _id, onBoardData, eligibilityResults, assignments, socialSupport_onboarded } = doc;
          const { parentFirstName, parentLastName, parentUsername, childUsername, childFirstName, childLastName } = onBoardData;
          const { caregiverHeight, caregiverWeight, caregiverBMI, youthHeight, youthWeight, youthGender, youthBMIResult, dob } = eligibilityResults;
          const healthcareCoach = assignments.assignedHealthcareCoach;
          const isSocialSupport =
            assignments.assignedArm === 'Social Support' &&
            (socialSupport_onboarded === false || socialSupport_onboarded === undefined);

          return (
            <div key={_id} style={{ border: '1px solid #ccc', padding: '1rem', borderRadius: '8px', width: '300px' }}>
              <h2 style={{ color: isSocialSupport ? 'red' : 'green' }}>{`${parentFirstName} ${parentLastName}`}</h2>
              {isSocialSupport && (
                <button onClick={() => onboardSocialSupport({ parent: { parentUsername, parentFirstName, parentLastName }, child: { childUsername, childFirstName, childLastName }, healthcareCoach })}>
                  Onboard Social Support
                </button>
              )}
              <button onClick={() => toggleDetails(_id)}>{expandedCardId === _id ? 'Hide Details' : 'View Details'}</button>
              {expandedCardId === _id && (
                <div>
                  <p><strong>Youth DOB:</strong> {dob}</p>
                  <p><strong>Youth Height:</strong> {metersToFeetInches(youthHeight)}</p>
                  <p><strong>Youth Weight:</strong> {kgsToLbs(youthWeight)} lbs</p>
                  <p><strong>Youth Gender:</strong> {youthGender.charAt(0).toUpperCase() + youthGender.slice(1)}</p>
                  <p><strong>Youth BMI:</strong> {youthBMIResult.bmi}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FitOnboardedDashboard;
